module.exports = __webpack_public_path__ + "5d0db6f9c24111b3dc040f624b60f4b8.jpg";